var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"history"}},[_c('sHeader',{attrs:{"activeIndex":1}}),_vm._v(" "),_c('div',{staticClass:"page-content videos"},[_vm._l((_vm.videos),function(item,index){return [_c('VideoItem',{key:index,attrs:{"data":item}})]})],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4967bfd6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MongolHistory.vue
// module id = null
// module chunks = 